/**
 * LexisNexis API Hooks
 */

import { useApiData, useAuthenticatedFetch } from './client';
import type { LexisNexisValidation, LexisNexisPreview, LexisNexisSource } from './types';

export function useLexisNexisSources(projectId: number | undefined) {
  const endpoint = projectId ? `/internal/datasources/lexisnexis/${projectId}` : null;
  return useApiData<LexisNexisSource[]>(endpoint || '/internal/datasources/lexisnexis/0');
}

export function useLexisNexisMutations() {
  const { fetchData: fetchValidation } = useAuthenticatedFetch<LexisNexisValidation>();
  const { fetchData: fetchPreview } = useAuthenticatedFetch<LexisNexisPreview>();
  const { fetchData: fetchRegister } = useAuthenticatedFetch<LexisNexisSource>();

  const validate = (
    query: string,
    dateRangeStart?: string,
    dateRangeEnd?: string
  ) =>
    fetchValidation('/internal/datasources/lexisnexis/validate', {
      method: 'POST',
      body: JSON.stringify({
        query,
        date_range_start: dateRangeStart,
        date_range_end: dateRangeEnd,
      }),
    });

  const preview = (
    query: string,
    dateRangeStart?: string,
    dateRangeEnd?: string
  ) =>
    fetchPreview('/internal/datasources/lexisnexis/preview', {
      method: 'POST',
      body: JSON.stringify({
        query,
        date_range_start: dateRangeStart,
        date_range_end: dateRangeEnd,
      }),
    });

  const register = (data: {
    query: string;
    id_project: number;
    date_range_start?: string;
    date_range_end?: string;
  }) =>
    fetchRegister('/internal/datasources/lexisnexis/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });

  return { validate, preview, register };
}
